<template>
  <div>
    <NavBar :admin="true" :items="items" />
    <v-main>
			<v-container>
        <v-progress-linear indeterminate color="primary" v-if="loading"></v-progress-linear>
        <template v-else>
          <v-row no-gutters class="mt-2">
            <b v-translate>Language:</b>
            <v-btn-toggle class="ml-2" v-model="language" mandatory>
              <v-btn value="pt" small class="text-overline" key="pt">
                <strong class="mr-1">PT</strong>
                <span v-translate>Portuguese</span>
              </v-btn>
              <v-btn value="en" small class="text-overline" key="en">
                <strong class="mr-1">EN</strong>
                <span v-translate>English</span>
              </v-btn>
              <v-btn value="es" small class="text-overline" key="es">
                <strong class="mr-1">ES</strong>
                <span v-translate>Spanish</span>
              </v-btn>
            </v-btn-toggle>
            <v-spacer></v-spacer>
            <v-alert v-model="success" color="alert" type="success">
              <translate>Saved Successfully</translate>
            </v-alert>
            <v-alert v-model="error" color="red" type="error">
              <translate>Error</translate>
            </v-alert>
          </v-row>
          <v-form ref="generalForm">
            <v-row no-gutters class="mt-4">
              <v-col cols="12" md="12">
                <v-card>
                  <v-card-title class="primary--text" key="general">
                    <translate>General</translate>
                  </v-card-title>
                  <v-card-text>
                    <v-row no-gutters>
                      <v-col cols="12" md="6">
                        <v-text-field
                          :rules="required"
                          v-model="group.info[language].name"
                          :label="$gettext('Name')"
                          outlined
                          class="px-2"
                        ></v-text-field>
                      </v-col>
                      <!-- <v-col cols="12" md="6">
                        <v-color-picker v-model="group.color" flat class="ma-2" hide-canvas hide-inputs></v-color-picker>
                      </v-col> -->
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
          <v-row no-gutters class="mt-4">
            <v-col cols="12" md="12">
              <v-card>
                <v-card-title class="primary--text" v-translate key="indications">Indications</v-card-title>
                <v-card-text>
                  <v-row no-gutters>
                    <v-col cols="12" md="12" class="px-2">
                      <v-textarea
                        outlined
                        :placeholder="$gettext('Write the group indications')"
                        v-model="group.info[language].indications"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="12" class="mt-4 px-2">
                      <SearchICD :selectedICD="group.indications_icd" context="new-product" />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-4">
            <v-col cols="12" md="12">
              <v-card>
                <v-card-title class="primary--text" v-translate key="indications">Contraindications</v-card-title>
                <v-card-text>
                  <v-row no-gutters>
                    <v-col cols="12" md="12" class="px-2">
                      <v-textarea
                        outlined
                        :placeholder="$gettext('Write the group contraindications')"
                        v-model="group.info[language].contraindications"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="12" class="mt-4 px-2">
                      <SearchICD :selectedICD="group.contraindications_icd" context="new-product" />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-4">
            <v-col cols="12" md="12">
              <v-btn
                color="primary"
                class="float-right ml-2"
                @click="editGroup"
                :loading="loading"
              >
                <translate>Save</translate>
              </v-btn>
              <v-btn color="primary" class="float-right" :to="{name: 'admin-acu-groups'}">
                <translate>Cancel</translate>
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import SearchICD from "@/components/icd/SearchICD.vue";

export default {
  name: "EditAcuGroup",
  components: {
    NavBar,
    SearchICD
  },
  data: () => ({
    language: 'pt',
    success: false,
    error: false,
    group: {
      info: {'pt': {name: ""}},
      indications_icd: [],
      contraindications_icd: [] 
    },
    loading: true
  }),
  computed: {
    items() {
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: "/admin/dashboard"
				},
				{
					text: this.$gettext("Acupuncture"),
					disabled: true,
          link: true,
          to: {name: "admin-acu-groups"}
        },
        {
					name: true,
					text: this.group.info['pt'].name,
					disabled: true,
					link: true
				},
				{
					text: this.$gettext("Edit"),
					disabled: true,
					link: true
				}
			];
    },
    required() {
			return [v => !!v || this.$gettext("Required")];
		}
  },
  methods: {
    editGroup() {
      if (this.$refs.generalForm.validate()) {
        let indications_icd = [];
        this.group.indications_icd.forEach(icd => {
          indications_icd.push({disease_id: icd.disease_id, degree: icd.degree});
        });
        let contraindications_icd = [];
        this.group.contraindications_icd.forEach(icd => {
          contraindications_icd.push({disease_id: icd.disease_id, degree: icd.degree});
        });
        
        let data = {
          id: this.group.id,
          form: true,
          //color: this.group.color,
          info: this.group.info,
          indications_icd: indications_icd,
          contraindications_icd: contraindications_icd
        }
				this.$store.dispatch("EDIT_GROUP", data).then(() => {
          this.success = true;
          window.scrollTo(0, 0);
        }).catch(() => {
          this.error = true;
          window.scrollTo(0, 0);
        });
      } else {
				window.scrollTo(0, 0);
			}
    }
  },
  created() {
    this.$store.dispatch("GET_GROUP_INFO", {id: this.$route.params.gid, form: true}).then((group) => {
      this.group = group;
      this.loading = false;
		});
  }
}
</script>